module.exports = __webpack_public_path__ + "static/media/default-man.4bd62b23.png";